// extracted by mini-css-extract-plugin
module.exports = {"title":"projectbox-module--title--3A2l-","subtitle":"projectbox-module--subtitle--3v9nO","text":"projectbox-module--text--22FBA","readMore":"projectbox-module--read-more--d2_ri"};